module.exports = __webpack_public_path__ + "img/1cd838aac4ff4aa8be5150fdcf2be2a3.7349e4c7.jpg";